import React, { useState, useEffect } from "react";
import AttendanceBookStatementComponent from "../Attendance-Book-statement/Component/AttendanceBookStatementComponent";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants/index";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";

const AttendanceBookStatement = () => {

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateNavbarHeading("Attendance Book Statement"));
  }, []);
  const [searchTerm, setSearchTerm] = useState("");
  const [attendanceStatementData, setAttendanceStatemnetData] = useState(
    []
  );
  const [calendarMonthOption, setCalendarMonthOption] = useState([]);
  const [branchOption, setBranchOption] = useState([]);
  const [employeeOption, setEmplooyeeOption] = useState([]);
  const [shiftOption, setShiftOption] = useState([]);
  const [attendanceStatusOption, setAttendanceStatusOPtion] = useState([]);
  const [filterFormData, setFilterData] = useState([]);
  const [apiStatus, SetApiStatus] = useState(undefined);

  const calendarMonthData = filterFormData.find((o) => o.label === "Month");
  const selectedMonth = calendarMonthOption?.find(
    (ele) => ele?.value === calendarMonthData?.value
  ) || {
    totalDays: 31,
    ShortMonth: "Day",
  };

  const columns = {
    EmployeeName: { text: "Employee", visible: true },
    PresentDays: {
      text: "Present Days",
      align: "center",
      visible: true,
      calculate: (rowData) => {
        // Count 'P' values in all day columns
        return Object.keys(rowData)
          .filter((key) => key.startsWith("Day"))
          .reduce(
            (count, day) => (rowData[day] === "P" ? count + 1 : count),
            0
          );
      },
    },
    AbsentDays: {
      text: "Absent Days",
      align: "center",
      visible: true,
      calculate: (rowData) => {
        // Count 'A' values in all day columns
        return Object.keys(rowData)
          .filter((key) => key.startsWith("Day"))
          .reduce(
            (count, day) => (rowData[day] === "A" ? count + 1 : count),
            0
          );
      },
    },
    PayrollCalculated: {
      text: "Payroll Calculated",
      align: "center",
      visible: true,
    },
    // Dynamic day columns will be inserted here
    ...Array.from({ length: selectedMonth.totalDays }, (_, i) => ({
      [`Day${i + 1}`]: {
        text: `${i + 1} ${selectedMonth.ShortMonth}`,
        align: "center",
        visible: true,
        width: "80px",
        type: "Select",
        option: attendanceStatusOption || [],
      },
    })).reduce((acc, cur) => ({ ...acc, ...cur }), {}),
    // Summary columns at the end

    ConfirmedBy: {
      text: "Approved By",
      visible: true,
    },
    ConfirmedDate: {
      text: "Approved Date",
      align: "center",
      type: "date",
      visible: true,
      width: "150px"
    },
    IsConfirmed: {
      text: "Confirmed",
      align: "center",
      type: "Text",
      visible: true,
      width: "150px"
    },
    Remark: {
      text: "Remark",
      align: "center",
      type: "Text",
      visible: true,
      width: "150px"
    },
  };

  // Final columns object
  const finalColumns = columns;

  const fetchLeaveStatement = async () => {
    SetApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}leave-statement/3?P_BranchID=2&P_ShiftID=&P_MonthID=&P_EmployeeID=&P_Status=`
      );
      SetApiStatus(response?.status);
      const cleanedData = response?.data;
      const monthOpt = cleanedData?.month?.map((ele) => ({
        value: ele?.value,
        label: ele?.text,
        totalDays: ele?.totalDays,
        ShortMonth: ele?.ShortMonth,
      }));
      setCalendarMonthOption(monthOpt);
      const branchOpt = cleanedData?.branch?.map((ele) => ({
        value: ele?.value,
        label: ele?.text,
      }));
      setBranchOption(branchOpt);
      const employeeOpt = cleanedData?.employeeList?.map((ele) => ({
        value: ele?.value,
        label: ele?.text,
      }));
      setEmplooyeeOption(employeeOpt);
      const shiftOpt = cleanedData?.shift?.map((ele) => ({
        value: ele?.value,
        label: ele?.text,
      }));
      setShiftOption(shiftOpt);
      const attendanceStatusOpt = cleanedData?.stats?.map((ele) => ({
        value: ele?.value,
        label: ele?.text,
        color: ele?.color,
      }));
      setAttendanceStatusOPtion(attendanceStatusOpt);
    } catch (error) {
      console.error("Error fetching job:", error);
    }
  };
  useEffect(() => {
    fetchLeaveStatement();
  }, []);

  const formDatas = [
    {
      name: "Branch",
      type: "Select",
      options: [...branchOption],
    },
    {
      name: "Month",
      type: "Select",
      options: [...calendarMonthOption],
    },
    {
      name: "Employee",
      type: "Select",
      options: [...employeeOption],
    },
    {
      name: "Shift",
      type: "Select",
      options: [...shiftOption],
    },
    {
      name: "Status",
      type: "Select",
      options: [...attendanceStatusOption],
    },
  ];

  const handleGetData = async (e) => {
    SetApiStatus(undefined)
    // const calendarMonth = filterFormData.find((o) => o.label === "Calendar Month")?.value;

    // Validation: Check if Calendar Month is blank
    // if (!calendarMonth) {
    //   e.stopPropagation();
    //   toast.error("Please select Calendar Month");
    //   return;
    // }
    try {
      const response = await GetServiceCaller(
        `${API_URL}leave-statement/3?P_BranchID=${filterFormData.find((o) => o.label === "Branch")?.value || 2
        }&P_ShiftID=${filterFormData.find((o) => o.label === "Shift")?.value || ""
        }&P_MonthID=${filterFormData.find((o) => o.label === "Month")?.value || 108
        }&P_EmployeeID=${filterFormData.find((o) => o.label === "Employee")?.value || ""
        }&P_Status=`
      );

      SetApiStatus(response?.status);
      if (response.status === 200) {
        const cleanedData = response?.data;
        const filtered = cleanedData?.result?.filter(el =>
          el.ConfirmedBy != '' &&
          el.ConfirmedDate != ''
        );


        const removedData
          = cleanedData?.result?.filter(el =>
            el.ConfirmedBy == '' &&
            el.ConfirmedDate == ''
          );
        setAttendanceStatemnetData(filtered);

        // setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };

  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const handleTextChange = (e) => {
    const { name, value } = e.target;
    console.log("name, value", name, value);
  };


  const handleReset = () => {
    fetchLeaveStatement()
    setFilterData([])
  }
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <AttendanceBookStatementComponent
              data={attendanceStatementData}
              columns={finalColumns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              filterFormData={filterFormData}
              setSearchTerm={setSearchTerm}
              handleTextChange={handleTextChange}
              isFilterRequired={true}
              handleReset={handleReset}
              formDatas={formDatas}
              handleGetData={handleGetData}
              handleChange={handleChange}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AttendanceBookStatement;
